
export class PurchaseCredit {
  purchaseCreditAmount: number | undefined;
  purchaseCreditType: string | undefined | null;
}
